"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryCarouselItem = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const components_1 = require("./CategoryCarouselItem/components");
exports.CategoryCarouselItem = (0, react_1.forwardRef)(({ img, title, category, slug }, ref) => {
    const productPath = (0, app_1.useContextPath)('ecommerce.product');
    return ((0, jsx_runtime_1.jsxs)(components_1.Wrap, Object.assign({ ref: ref }, { children: [(0, jsx_runtime_1.jsx)(components_1.ImgWrap, { children: (0, jsx_runtime_1.jsx)(app_1.Image, { img: img }) }), (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: `${productPath}/${slug}` }, { children: (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(components_1.Category, { children: category }), (0, jsx_runtime_1.jsx)(components_1.Title, { children: title })] })) }))] })));
});
